import {
  motion,
  useMotionValue,
  useTransform,
  animate,
  useInView,
} from "framer-motion";
import { useEffect, useRef } from "react";

export interface CounterProps {
  from: number;
  to: number;
  duration?: number;
  sub?: string;
  prefix?: string;
}

export const Counter = ({
  from,
  to,
  duration = 1,
  sub = "",
  prefix = "",
}: CounterProps) => {
  const ref = useRef<HTMLParagraphElement>(null);

  const isInView = useInView(ref);
  const count = useMotionValue(from);
  const rounded = useTransform(
    count,
    (latest) => `${prefix}${Math.round(latest).toLocaleString("ru-RU")}${sub}`,
  );

  useEffect(() => {
    if (!isInView) return;

    const controls = animate(count, to, { duration: duration });
    return controls.stop;
  }, [count, duration, to, isInView]);

  return (
    <motion.p ref={ref} viewport={{ once: true }}>
      {rounded}
    </motion.p>
  );
};
